import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="mb-8" data-id="element-44">
      <h2 className="text-2xl font-bold mb-6 text-blue-900 text-center" data-id="element-45">
        Final Thoughts
      </h2>
      <p className="text-lg mb-6 text-center" data-id="element-46">
        Petssey DNRx is the simple, safe, affordable way to love your cat and
        love your home again.
      </p>
      <div className="max-w-md mx-auto mb-8" data-id="element-47">
        <div className="flex items-start mb-3" data-id="element-48">
          <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-49" />
          <span className="text-lg" data-id="element-50">Breathe easier around your cat</span>
        </div>
        <div className="flex items-start mb-3" data-id="element-51">
          <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-52" />
          <span className="text-lg" data-id="element-53">No filters, no ongoing costs</span>
        </div>
        <div className="flex items-start mb-3" data-id="element-54">
          <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-55" />
          <span className="text-lg" data-id="element-56">Safe, silent, 24/7 protection</span>
        </div>
        <div className="flex items-start mb-3" data-id="element-57">
          <CheckIcon className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-58" />
          <span className="text-lg" data-id="element-59">Backed by a 45-day money-back promise</span>
        </div>
      </div>
      <div className="text-center" data-id="element-60">
        <a href="https://petssey.com/products/petssey-dnrx" className="inline-flex items-center justify-center px-8 py-4 text-xl font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition-colors" data-id="element-61">
          Order Petssey DNRx Now — Limited Australian Stock
        </a>
      </div>
      <div className="flex justify-center mb-8 mt-12" data-id="element-62">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3eAzup5vTxzM9yJkckzAhy/ChatGPT_Image_Sep_1%2C_2025%2C_02_54_37_PM.png" alt="Petssey DNRx device with blue light plugged into wall outlet next to a cozy beige couch with knitted blanket" className="w-3/2 rounded-lg shadow-md" data-id="element-63" />
      </div>
      <div className="max-w-4xl mx-auto mt-16 text-sm text-gray-700" data-id="element-64">
        <h3 className="font-semibold mb-4" data-id="element-65">Scientific Citations</h3>
        <ol className="list-decimal pl-5 space-y-3" data-id="element-66">
          <li data-id="element-67">
            Reynolds, Lisa A., <em data-id="element-68">et al.</em> "Managing Cat Allergens: Fel d 1
            Environmental and Immunological Control Measures."{' '}
            <em data-id="element-69">Journal of Feline Medicine and Surgery</em>, vol. 21, no. 11,
            2019, pp. 1046–1053.{' '}
            <a href="https://doi.org/10.1177/1098612X19861218" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-70">
              https://doi.org/10.1177/1098612X19861218
            </a>
          </li>
          <li data-id="element-71">
            Dyson Newsroom. "The Truth About Pet Hair and Allergens." Dyson, 21
            Apr. 2022.{' '}
            <a href="https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-72">
              https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens
            </a>
          </li>
          <li data-id="element-73">
            AchooAllergy. "Facts about Animal Dander and Allergies." 2023.{' '}
            <a href="https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-74">
              https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/
            </a>
          </li>
          <li data-id="element-75">
            Gong, Tao, <em data-id="element-76">et al.</em> "Cat Allergens: Diagnosis and
            Immunotherapy."{' '}
            <em data-id="element-77">Clinical Reviews in Allergy &amp; Immunology</em>, vol. 63, no.
            1, 2021, pp. 58–74. PubMed Central (PMC).{' '}
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-78">
              https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/
            </a>
          </li>
          <li data-id="element-79">
            "Struggle to Snuggle: The Impact of Cat Allergens on Cat Owners."
            DVM360, 6 Dec. 2018.{' '}
            <a href="https://www.dvm360.com/view/struggle-to-snuggle-the-impact-of-cat-allergens-on-cat-owners" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-80">
              https://www.dvm360.com/view/struggle-to-snuggle-the-impact-of-cat-allergens-on-cat-owners
            </a>
          </li>
          <li data-id="element-81">
            Dyson Newsroom (2022) and AchooAllergy (2023). Combined sources on
            HEPA limitations and ongoing filter costs.{' '}
            <a href="https://www.dyson.com.sg/newsroom/truth-about-pet-hair-and-allergens" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-82">
              Dyson article
            </a>{' '}
            ·{' '}
            <a href="https://www.achooallergy.com/blog/learning/facts-about-animal-dander-and-allergies/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-83">
              AchooAllergy article
            </a>
          </li>
          <li data-id="element-84">
            Reynolds, L. A., <em data-id="element-85">et al.</em> (2019) and Gong, T.,{' '}
            <em data-id="element-86">et al.</em> (2021). Environmental allergen control and particle
            aggregation mechanisms supporting ion-mediated agglomeration.{' '}
            <a href="https://doi.org/10.1177/1098612X19861218" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-87">
              Reynolds 2019
            </a>{' '}
            ·{' '}
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8721548/" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-88">
              Gong 2021
            </a>
          </li>
          <li data-id="element-89">
            National Institute for Occupational Safety and Health (NIOSH), U.S.
            CDC. "Ozone Generators and Indoor Air Quality." 2022. Guidance on
            avoiding ozone-generating devices; modern consumer ionisers marketed
            as ozone-safe should meet applicable safety limits.{' '}
            <a href="https://www.cdc.gov/niosh/topics/indoorenv/ozone.html" target="_blank" rel="noopener" className="text-blue-600 underline" data-id="element-90">
              https://www.cdc.gov/niosh/topics/indoorenv/ozone.html
            </a>
          </li>
        </ol>
      </div>
      <div className="text-center text-sm text-gray-500 mt-12" data-id="element-91">
        <p data-id="element-92">© 2025 Petssey. All Rights Reserved.</p>
        <p data-id="element-93">
          Results may vary. This is an advertorial and not an actual news
          article.
        </p>
      </div>
    </footer>;
}